import app from "../_app";

const promobar = document.querySelector('.js-promobar');
const header = document.querySelector('.header__sticky');
if(promobar) {

    if(promobar.classList.contains('non-sticky')){
        window.addEventListener("scroll", () => {
            let scrollY = window.scrollY;
            const promobarHeight = promobar.offsetHeight;

            if (scrollY > 0) {
                promobar.classList.add("hide");
                header.classList.add("hide");
                header.style.top = `-${promobarHeight}px`;
            } else {
                promobar.classList.remove("hide");
                header.classList.remove("hide");
                header.style.top = '0';
            }
        });
    }

    const countDown = promobar.querySelector('.js-promobar-countdown');

    if(countDown) {
        const countDownDate = new Date(countDown.getAttribute('data-date')).getTime();

        const countDownInterval = setInterval(() => {
            const now = new Date().getTime();
            const distance = countDownDate - now;
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            let countdownText = '';

            // Show days if there are any
            if (days > 0) {
                countdownText += `${days} ${days > 1 ? app.translationHelper('days') : app.translationHelper('day')} `;
            }

            // Show hours if there are any OR if there are days
            if (hours > 0 || days > 0) {
                countdownText += `${hours} ${hours > 1 ? app.translationHelper('hours') : app.translationHelper('hour')} `;
            }

            // Show minutes if there are any OR if there are hours or days
            if (minutes > 0 || hours > 0 || days > 0) {
                countdownText += `${minutes} ${minutes > 1 ? app.translationHelper('minutes') : app.translationHelper('minute')} `;
            }

            // Show seconds if there are any OR if there are minutes, hours or days
            if (seconds > 0 || minutes > 0 || hours > 0 || days > 0) {
                countdownText += `${seconds} ${seconds > 1 ?  app.translationHelper('seconds') :  app.translationHelper('second')}`;
            }

            countDown.innerHTML = countdownText;

            if (distance < 0) {
                clearInterval(countDownInterval);
                countDown.innerHTML = "";
            }
        }, 1000);
    }
}
